export const GOOGLE_SCRIPT_SRC = '//accounts.google.com/gsi/client'
export const FACEBOOK_SCRIPT_SRC = '//connect.facebook.net/en_GB/all.js'
export const APPLE_SCRIPT_SRC =
  '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
